import { useState, useRef, useEffect } from "react";
import "./FuesResponsiveDropdown.css";

function FuesResponsiveDropdown({ label = "Collections", items = [] }) {
  const [open, setOpen] = useState(false);
  const [dropUp, setDropUp] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
  const wrapperRef = useRef(null);

  const toggleDropdown = () => setOpen((prev) => !prev);

  // Close dropdown if click happens outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  // Handle drop-up/drop-down
  useEffect(() => {
    if (open && buttonRef.current && menuRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const menuHeight = menuRef.current.offsetHeight;
      const spaceBelow = window.innerHeight - buttonRect.bottom;
      const spaceAbove = buttonRect.top;

      // Open upwards if not enough space below
      setDropUp(spaceBelow < menuHeight && spaceAbove > menuHeight);
    }
  }, [open]);

  return (
    <div className="fues-dropdown" ref={wrapperRef}>
      <button
        ref={buttonRef}
        onClick={toggleDropdown}
        className="fues-dropdown-btn"
      >
        {label} <i className="fi fi-rr-angle-small-down"></i>
      </button>

      {open && (
        <div
          ref={menuRef}
          className={`fues-dropdown-menu ${
            dropUp ? "fues-drop-up" : "fues-drop-down"
          }`}
        >
          {items.map((item, index) => (
            <a key={index} href={item.href}>
              {item.label}
            </a>
          ))}
        </div>
      )}
    </div>
  );
}

export default FuesResponsiveDropdown;
